module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "block"
  }, [_c('b-switch', {
    model: {
      value: (_vm.allowNew),
      callback: function($$v) {
        _vm.allowNew = $$v
      },
      expression: "allowNew"
    }
  }, [_vm._v("\n                Allow new tags\n            ")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.openOnFocus),
      callback: function($$v) {
        _vm.openOnFocus = $$v
      },
      expression: "openOnFocus"
    }
  }, [_vm._v("\n                Open on focus\n            ")])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Enter some tags"
    }
  }, [_c('b-taginput', {
    attrs: {
      "data": _vm.filteredTags,
      "autocomplete": "",
      "allow-new": _vm.allowNew,
      "open-on-focus": _vm.openOnFocus,
      "field": "user.first_name",
      "icon": "label",
      "placeholder": "Add a tag"
    },
    on: {
      "typing": _vm.getFilteredTags
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('pre', {
    staticStyle: {
      "max-height": "400px"
    }
  }, [_c('b', [_vm._v("Tags:")]), _vm._v(_vm._s(_vm.tags))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24460394"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/taginput/examples/ExAutocomplete.vue
// module id = 1253
// module chunks = 7 56